module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/thumbs/59-1e52eba6c2c49e2c9dc62562374e8879.webp";